import React from 'react';
import PropTypes from 'prop-types';

import MenuHeader from './MenuHeader';

const DateTimeMenu = ({ name }) => {
    const options = {
      year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric',
    };
    const currentDate = new Intl.DateTimeFormat('en-US', options).formatToParts(new Date());
    return (
      <>
        <MenuHeader itemName={name} />
        <div className="Set-options-container">
          <div className="Set-options">{currentDate.map((el, index) => <div key={index} className="Set-option-item">{el.value}</div>)}</div>
          <div className="Set-button Button-active">Set</div>
        </div>
      </>
    );
  };
  
DateTimeMenu.propTypes = {
    name: PropTypes.string.isRequired,
};

export default DateTimeMenu;
  